<template>
  <header>
    <div id="main-menu">
      <div class="main-menu main-menu-container1">
        <div class="container">
          <div class="navbar-header float-left">
            <a class="navbar-brand text-uppercase" href="/index" style="height: 80px;display: flex; align-items: center;">
              <img :src="logoURL" alt="logo" style="height: 38px;"></a>
          </div>
          <div class="site-title">
            {{projectTitle}}
          </div>
        </div>
      </div>
      <div class="main-menu main-menu-container1" style="  height: 48px; background-color: #0073cc;">
        <div class="container">
          <div class="navbar-default">
            <div class="navbar-header float-left">
              <a class="navbar-brand text-uppercase navbar-brand-text" href="/index">主页</a>
            </div>
            <k-login></k-login>
            <nav class="navbar-menu float-right">
              <div class="nav-menu ul-li">
                <li style="color: transparent;">
                </li>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import Cookies from 'js-cookie'
import { ProjectSettings } from '@/views/base/base.js'

export default {
  name: 'jxsz-header',
  props: {
  },
  data() {
    return {
      projectTitle: ProjectSettings.Title,
      logoURL: ProjectSettings.LogoURL
    }
  },
  mounted() {
    this.displayName = Cookies.get('DisplayName');
  },
  methods: {
    onIndex() {
      this.$router.push({ name: 'index' });
    },
    onSupermarket() {
      this.$router.push({ name: 'supermakrket' });
    },
    toIndexSection(id) {
      console.log('route.name', this.$route.name);
      if (this.$route.name !== 'index') {
        this.$router.push({ name: 'index', query: { toSection: id } });
      } else {
        $('html,body').animate({ scrollTop: $('#' + id).offset().top }, 1000);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-menu-container1 {
  background-image: none;
  background-color: #fff;
  padding: 0;
  .site-title {
    font-size: 32px;
    color: #0073cc;
    line-height: 80px;
    cursor: default;
  }

  .navbar-brand-text {
    color: #0073cc;
    line-height: 48px;
    padding: 0;
    background-color: #fff;
    width: 150px;
    text-align: center;
  }
}
</style>
<style scoped>
.main-menu >>> .nav-menu {
  padding-top: 13px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/ncrq/header.vue